export function buildLoginRedirectUrl(currentPath: string, currentSearch: string = ''): string {
  const fullPath = currentPath + currentSearch;
  if (
    fullPath.startsWith('/login') ||
    fullPath.startsWith('/register') ||
    fullPath.startsWith('/forgot-password') ||
    fullPath.startsWith('/admin/login')
  ) {
    return '/login';
  }
  return '/login?redirect=' + encodeURIComponent(fullPath);
}

export function getRedirectUrl(
  searchParams: URLSearchParams,
  userRole: { isAdmin?: boolean; isFamily?: boolean; isTeacher?: boolean }
): string | null {
  const redirect = searchParams.get('redirect');
  if (!redirect) return null;

  // Previene open redirect: solo path relativi
  if (redirect.startsWith('http') || redirect.startsWith('//')) return null;

  // Valida che il redirect corrisponda al ruolo dell'utente
  if (redirect.startsWith('/family') && !userRole.isFamily) return null;
  if (redirect.startsWith('/teacher') && !userRole.isTeacher) return null;
  if (redirect.startsWith('/admin') && !userRole.isAdmin) return null;

  // Previene loop di redirect
  if (redirect === '/login' || redirect === '/admin/login') return null;

  return redirect;
}
